import registerAuthPages from './register-auth-pages/'
import syncUserWithAuth from './sync-user-with-auth/'

export default () => {
  registerAuthPages()
  syncUserWithAuth()
}
